// Popover for the message action menus (Export / More / Share to project).
// Rendered in a portal on <body> with fixed positioning so it is never
// clipped by the chat scroller or trapped under a transformed message row.
// Opens above the anchor when there is room, otherwise below, and stays
// inside the viewport horizontally.
import { useLayoutEffect, useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { placeMenu } from "./popMenuPlace.js";

export default function PopMenu({ anchorRef, onClose, style, children }) {
  const menuRef = useRef(null);
  const [pos, setPos] = useState(null);

  useLayoutEffect(() => {
    const place = () => {
      const a = anchorRef.current, m = menuRef.current;
      if (!a || !m) return;
      setPos(placeMenu(a.getBoundingClientRect(), { width: m.offsetWidth, height: m.scrollHeight }, window.innerWidth, window.innerHeight));
    };
    place();
    window.addEventListener("resize", place);
    return () => window.removeEventListener("resize", place);
  }, [anchorRef]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    // The anchor moves with the chat, so close rather than float detached.
    const onScroll = (e) => { if (!menuRef.current?.contains(e.target)) onClose(); };
    window.addEventListener("keydown", onKey);
    window.addEventListener("scroll", onScroll, true);
    return () => { window.removeEventListener("keydown", onKey); window.removeEventListener("scroll", onScroll, true); };
  }, [onClose]);

  return createPortal(
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 9998 }} />
      <div ref={menuRef} role="menu" style={{
        ...style, position: "fixed", bottom: "auto", zIndex: 9999, overflowY: "auto",
        fontFamily: "var(--cf-brand-font, inherit)",
        top: pos ? pos.top : -9999, left: pos ? pos.left : -9999,
        maxHeight: pos ? Math.min(pos.maxHeight, style?.maxHeight || Infinity) : style?.maxHeight,
        visibility: pos ? "visible" : "hidden",
      }}>
        {children}
      </div>
    </>,
    document.body
  );
}
